import * as React from 'react';
import styled from '@emotion/styled';
import { Theme } from '@emotion/react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Btn, useButton } from '../../hooks/useButton';
import { Font } from '../../fonts';

export enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export interface ButtonWidgetProps extends Btn {
  type?: ButtonType;
  className?: any;
}

export const ButtonWidget: React.FC<ButtonWidgetProps> = (props) => {
  const type = props.type || ButtonType.PRIMARY;
  const btn = useButton(props);
  return (
    <S.Container className={props.className} type={type} {...btn}>
      <S.Label disabled={props.disabled} _hidden={props.loading} type={type}>
        {props.label}
      </S.Label>
      {props.loading ? (
        <S.Center type={type}>
          <FontAwesomeIcon icon={faSpinner} spin={true} />
        </S.Center>
      ) : null}
    </S.Container>
  );
};
namespace S {
  const getTheme = (theme: Theme, type: ButtonType) => {
    if (type === ButtonType.PRIMARY) {
      return theme.button_primary;
    }
    return theme.button_secondary;
  };

  export const Container = styled.div<{ type: ButtonType }>`
    background: ${(p) => getTheme(p.theme, p.type).background};
    padding: 10px;
    border-radius: 3px;
    cursor: pointer;
    position: relative;

    &:hover {
      background: ${(p) => getTheme(p.theme, p.type).background_hover};
    }
  `;

  export const Label = styled.div<{ type: ButtonType; _hidden: boolean; disabled: boolean }>`
    text-align: center;
    font-family: ${Font.Special};
    opacity: ${(p) => (p._hidden ? 0.1 : p.disabled ? 0.5 : 1)};
    {p => }
    color: ${(p) => getTheme(p.theme, p.type).foreground};
  `;

  export const Center = styled.div<{ type: ButtonType }>`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) !important;
    color: ${(p) => getTheme(p.theme, p.type).foreground};
  `;
}
